import { Button, HStack, useToast, VStack, Text, Checkbox, Box, Collapse, Flex } from "@chakra-ui/react";
import SelectDateMonth from "../select_date_month";
import SelectDateDays from "../select_date_days";
import SelectDateYear from "../select_date_year";
import SelectSection from "../select_section";
import SelectPeriod from "./select_period";
import ModalSelectStaffYears from "../modal_select_staff_years";

import ModalSelectManagers from "../modal_select_managers";
import baseUrl from "../../vars";
import { authFetch } from "../../auth/auth";
import { observer } from "mobx-react-lite";
import { useStores } from "../../store/store_context";
import { useEffect, useState, useRef } from "react";
import SelectGroupBy from "./select_group_by";
import SelectBackup from "../select_backups";
import SelectBind from "../select_bind";


const FiltersGrid = observer(({ renderButtons }) => {
  const { pageStore } = useStores();
  const [loading, setLoading] = useState(false);

  const toast = useToast();

  const [requestTime, setRequestTime] = useState(0);
  const [isTimerActive, setIsTimerActive] = useState(false);
  const timerRef = useRef(null);

  const handleCancel = () => {
    if (pageStore.abortControllerRef) {
      pageStore.abortControllerRef.abort();
      console.log('Нажата кнопка отмены');
    }
  };

  const startTimer = () => {
    setIsTimerActive(true);
    const startTime = Date.now();
    setRequestTime(0);
    pageStore.setRequestTime(0);

    if (timerRef.current) clearInterval(timerRef.current);

    timerRef.current = setInterval(() => {
      setRequestTime((Date.now() - startTime) / 1000);
      pageStore.setRequestTime((Date.now() - startTime) / 1000);
    }, 50);
  };

  const stopTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
    setIsTimerActive(false);
  };

  useEffect(() => {
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);


  const params = new URLSearchParams();
  if (pageStore.selected_managers && pageStore.selected_managers.length) {
    pageStore.selected_managers.forEach((manager) =>
      params.append("managers", manager)
    );
  }

  const fetchMops = async () => {
    setLoading(true);
    pageStore.abortControllerRef = new AbortController();
    const { signal } = pageStore.abortControllerRef;
    startTimer();
    pageStore.setLoading(true)
    pageStore.clearDataMops();

    try {
      while (true) {
        await new Promise(resolve => setTimeout(resolve, 0));
        const query = new URLSearchParams(params.toString());

        if (pageStore.start_date_day || pageStore.start_date_month || pageStore.start_date_year) {
          const start = new Date(
            pageStore.start_date_day || pageStore.start_date_month || pageStore.start_date_year
          )
            .toISOString()
            .split("T")[0];
          query.append("start", start);
        }

        if (pageStore.end_date_day || pageStore.end_date_month || pageStore.end_date_year) {

          const date = new Date(
            pageStore.end_date_day || pageStore.end_date_month || pageStore.end_date_year
          )
          const end = [
            date.getFullYear(),
            String(date.getMonth() + 1).padStart(2, "0"),
            String(date.getDate()).padStart(2, "0"),
          ].join("-");
          query.append("end", end);
        }

        if (pageStore.selected_one_department)
          query.append("departament", pageStore.selected_one_department);

        if (pageStore.selected_staff_years) {
          query.append("staff_year", pageStore.selected_staff_years)
        }

        const res = await authFetch(`${baseUrl}/api/mops?${query}`, {
          method: "GET",
          signal: signal,
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${pageStore.token}`,
            "X-Database": pageStore.select_backup != "" ? "temp" : "main"
          },
        });
        const json = await res.json();
        const data = json.data || [];

        pageStore.addDataMops(data);
        //if (data.length < count || pageStore.data_payments.length >= total)
        break;
      }
    } catch (err) {
      toast({
        title: "Ошибка загрузки МОПов",
        description: err.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      pageStore.abortControllerRef = null;
      pageStore.setLoading(false)
      setLoading(false);
      stopTimer();
    }
  };

  const buttons = (
    <>
      <Button
        onClick={fetchMops}
        bg="#333"
        color="white"
        w={{ base: "100%", md: "15vw" }}
        isLoading={loading}
        _hover={{
          background: "#444",
        }}
        mr={3}
      >
        Сформировать
      </Button>
      <Button
        onClick={() => pageStore.resetFilters()}
        bg="#333"
        color="white"
        w={{ base: "100%", md: "15vw" }}
        _hover={{
          background: "#444",
        }}
        mr={3}
      >
        Сбросить фильтры
      </Button>
      <Button
        onClick={() => handleCancel()}
        bg="#333"
        color="white"
        w={{ base: "100%", md: "15vw" }}
        _hover={{
          background: "#444",
        }}
      >
        Отменить запрос
      </Button>
    </>
  )


  return (
    <>
      <Box position="relative" w="100%">
        <VStack width="100%" align="center" px={{ base: "10px", md: "20px" }}>
          <Collapse in={pageStore.open_filter} animateOpacity style={{ width: '100%' }}>
            <Box w="100%">
              <VStack w="100%" gap={{ base: "30px", md: "50px" }}>

                {/* Блок 1: Период */}
                <Flex
                  justify="center"
                  wrap="wrap"
                  gap={2}
                  direction={{ base: "column", sm: "row" }}
                  align="center"
                >
                  <Text whiteSpace={"nowrap"} fontSize={"16px"} fontWeight={"600"} textColor={"white"}>
                    Период:
                  </Text>
                  <HStack>
                    <SelectDateDays />
                    <SelectDateMonth />
                    <SelectDateYear />
                  </HStack>
                </Flex>

                {/* Блок 2: Менеджеры и группировка */}
                <Flex
                  direction={{ base: "column", lg: "row" }}
                  align={{ base: "center", lg: "start" }}
                  gap={6}
                >
                  <HStack alignItems={"center"}>
                    <Text fontWeight={"600"} fontSize={"16px"} color={"white"}>
                      Менеджеры:
                    </Text>
                    <ModalSelectManagers left={{ base: "0", md: "-300px" }} />
                  </HStack>

                  <Flex gap={2} wrap="wrap" justify="center">
                    <SelectSection />
                    <SelectGroupBy />
                  </Flex>
                </Flex>

                {/* Блок 3: Чекбоксы и дополнительные настройки */}
                <Flex
                  direction={{ base: "column", md: "row" }}
                  wrap="wrap"
                  justify="center"
                  align={{ base: "stretch", md: "start" }}
                  gap={4}
                >
                  {/* Группа чекбоксов 1 */}
                  <VStack
                    align="start"
                    spacing={2}
                    bg="#333"
                    p={3}
                    borderRadius="10px"
                    color="#EEEEEE"
                    w={{ base: "100%", sm: "auto" }}
                    h="fit-content" // Дополнительно указываем высоту по контенту
                  >
                    <Checkbox
                      colorScheme="green"
                      isChecked={pageStore.absolute_column_mops}
                      onChange={(e) => pageStore.setAbsoluteColumnMops(e.target.checked)}
                      size={{ base: "sm", md: "md" }}
                    >
                      Абсолютные значения
                    </Checkbox>
                    <Checkbox
                      colorScheme="green"
                      isChecked={pageStore.percent_column_mops}
                      onChange={(e) => pageStore.setPercentColumnMops(e.target.checked)}
                      size={{ base: "sm", md: "md" }}
                    >
                      Прирост, %
                    </Checkbox>
                    <Checkbox
                      colorScheme="green"
                      isChecked={pageStore.part_column_mops}
                      onChange={(e) => pageStore.setPartColumnMops(e.target.checked)}
                      size={{ base: "sm", md: "md" }}
                    >
                      Доли, %
                    </Checkbox>
                  </VStack>

                  <ModalSelectStaffYears />

                  {/* Группа чекбоксов 2 */}
                  <VStack
                    align="start"
                    spacing={2}
                    bg="#333"
                    p={3}
                    borderRadius="10px"
                    color="#EEEEEE"
                    w={{ base: "100%", sm: "auto" }}
                    h="fit-content" // Дополнительно указываем высоту по контенту
                  >
                    <Checkbox
                      colorScheme="green"
                      isChecked={pageStore.workers}
                      onChange={(e) => pageStore.setWorkers(e.target.checked)}
                      size={{ base: "sm", md: "md" }}
                    >
                      Работающие
                    </Checkbox>
                  </VStack>

                  <Flex gap={4} wrap="wrap" justify="center">
                    <SelectBackup />
                    <SelectBind report_name={"mops"} />
                  </Flex>
                </Flex>

              </VStack>

              <Box mt="30px">
                <SelectPeriod />
              </Box>
            </Box>
          </Collapse>
        </VStack>
      </Box >
      <Collapse in={pageStore.open_filter} animateOpacity>
        {renderButtons ? renderButtons(buttons) : buttons}
      </Collapse>
    </>
  );
});

export default FiltersGrid;
